import axios from 'axios';

export function getMotivations() {
    return axios.get(
        `${process.env.REACT_APP_REPO}/v1/repo_aden/miscs/motivations`
    );
}
